// extracted by mini-css-extract-plugin
module.exports = {"avatar":"userDetails_avatar__35zzN"};